<section class="demo-wrapper">
  <header class="demo-header">
    <h1>PrimeNG Select Styling Sandbox</h1>
    <p>
      This page renders PrimeNG <code>p-select</code> and <code>p-dropdown</code> components inside the current app shell,
      so we can spot interference from global styling (Tailwind, custom SCSS, zoom tweaks, etc.).
    </p>
  </header>

  <article class="demo-card">
    <h2>Filters</h2>
    <div class="field-grid">
      <div class="field">
        <label for="projectSelect">Project</label>
        <p-select
          inputId="projectSelect"
          [options]="projectOptions"
          [(ngModel)]="selectedProject"
          optionLabel="label"
          placeholder="Choose project"
          class="w-full"
        />
      </div>

      <div class="field">
        <label for="statusSelect">Status</label>
        <p-select
          inputId="statusSelect"
          [options]="statusOptions"
          [(ngModel)]="selectedStatus"
          optionLabel="label"
          placeholder="Choose status"
          class="w-full"
        />
      </div>

      <div class="field">
        <label for="themeSelect">Theme</label>
        <p-select
          inputId="themeSelect"
          [options]="themeOptions"
          [(ngModel)]="selectedTheme"
          (ngModelChange)="onThemeSelected($event)"
          optionLabel="label"
          placeholder="Pick theme"
          class="w-full"
        />
      </div>
    </div>

    <div class="field">
      <label for="keyword">Keyword</label>
      <input
        id="keyword"
        type="text"
        pInputText
        [(ngModel)]="keyword"
        placeholder="Try typing here to inspect text styles"
      />
    </div>

    <footer class="actions">
      <p-button label="Cycle Theme" icon="pi pi-refresh" (onClick)="cycleTheme()"></p-button>
      <p-button label="Clear" severity="secondary" icon="pi pi-times" styleClass="p-button-text"></p-button>
    </footer>
  </article>

  <aside class="notes">
    <h3>What to look for</h3>
    <ul>
      <li>The overlay panels should align directly under the triggers (no horizontal offset).</li>
      <li>Spacing, padding, and typography should match the active PrimeNG theme.</li>
      <li>If something looks off here but not in a fresh Angular CLI project, the issue is likely global styles.</li>
    </ul>
  </aside>
</section>
